// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__IpTb7","logo":"styles_logo__1GZgK"};